export const translations = {
  english: {
    // Header
    inAssociationWith: "In association with",
    
    // User Data Labels
    name: "Name",
    mobile: "Mobile",
    address: "Address",
    cityState: "City/State",
    previousCrop: "Previous Crop",
    farmSize: "Farm Size",
    nextCrop: "Next Crop",
    sampleCode: "Sample Code",
    treatmentType: "Treatment Type",
    
    // Section Titles
    section1Title: "Section 1: Soil Analysis Summary",
    section1Subtitle: "This is what we tested in your soil sample.",
    section2Title: "Section 2: Detailed Nutrient Insights",
    section2Subtitle: "Deep-dive into each tested parameter.",
    section3Title: "Section 3: Fertilizer Recommendation",
    section3Subtitle: "This page tells you exactly what fertilizers to use, how much, and when. Follow this plan.",
    section4Title: "Section 4: Derived Insights & Nutrient Balance",
    section4Subtitle: "This section gives deeper insights. Useful but not mandatory to read.",
    section5Title: "Section 5: Crop-Specific Tips",
    section5Subtitle: "Expert tips for cultivation. Follow these practices for better results.",
    
    // Table Headers - Soil Analysis
    sNo: "S. No.",
    parameter: "Parameter",
    idealRange: "Ideal Range",
    actualValue: "Actual Value",
    status: "Status",
    derivedParameters: "Derived Parameters",
    
    // Table Headers - Detailed Insights
    fertilityRating: "Fertility Rating",
    whatItMeans: "What it means?",
    functionInCropGrowth: "Function in Crop Growth",
    
    // Nutrient Insights - Meanings
    phMeaning: "Acidity/alkalinity of soil",
    ecMeaning: "Salt level in soil",
    ocMeaning: "Soil organic matter",
    nitrogenMeaning: "Growth nutrient",
    phosphorusMeaning: "Energy transfer",
    potassiumMeaning: "Fruit quality regulator",
    sulphurMeaning: "Protein synthesis",
    magnesiumMeaning: "Core of chlorophyll",
    calciumMeaning: "Cell strength",
    zincMeaning: "Growth hormone support",
    ironMeaning: "Chlorophyll synthesis",
    copperMeaning: "Enzyme activator",
    boronMeaning: "Pollination & fruit set",
    
    // Nutrient Insights - Functions
    phFunction: "Affects nutrient availability and microbial activity",
    ecFunction: "Influences root water uptake and nutrient solubility",
    ocFunction: "Enhances microbial life, structure, and water retention",
    nitrogenFunction: "Promotes leafy growth and chlorophyll formation",
    phosphorusFunction: "Supports root development and flowering",
    potassiumFunction: "Helps in water balance, disease resistance, fruit size",
    sulphurFunction: "Improves enzyme function, oil synthesis, and taste",
    magnesiumFunction: "Essential for photosynthesis and enzyme activation",
    calciumFunction: "Builds strong cell walls, prevents blossom-end rot",
    zincFunction: "Needed for enzyme activation, leaf expansion, rooting",
    ironFunction: "Supports green leaf formation and respiration",
    copperFunction: "Influences pollen viability and disease resistance",
    boronFunction: "Aids flowering, fruit set, sugar transport, and seed formation",
    
    // Derived Insights - Meanings
    cnRatioMeaning: "Ratio of soil Organic carbon to available nitrogen",
    cecTendencyMeaning: "Soil's capacity to hold and exchange nutrients (based on OC, Ca, Mg, K, pH)",
    caMgRatioMeaning: "Balance between calcium and magnesium levels in soil",
    kMgRatioMeaning: "Balance between potassium and magnesium availability",
    
    // Derived Insights - Functions
    cnRatioFunction: "Indicates quality of organic matter; affects microbial activity and nitrogen availability",
    cecTendencyFunction: "Influences root water uptake and nutrient solubility",
    caMgRatioFunction: "Influences soil structure, aeration, water movement, and root penetration",
    kMgRatioFunction: "Controls competition for uptake; affects fruit quality, stress tolerance, and leaf strength",
    
    // Derived Indicators - Effects
    cnRatioLowEffect: "Fast breakdown of organic matter, increased nitrate leaching",
    cnRatioHighEffect: "Nutrient lock-up, slower nitrogen mineralization",
    cecTendencyLowEffect: "Poor nutrient retention, higher risk of leaching",
    cecTendencyHighEffect: "Nutrients may bind too tightly",
    caMgRatioLowEffect: "Soil compaction, poor aeration, reduced water infiltration",
    caMgRatioHighEffect: "Nutrient antagonism, especially Mg and K deficiency",
    kMgRatioLowEffect: "Potential Mg excess, may delay fruit maturity",
    kMgRatioHighEffect: "K suppresses Mg uptake, weak stems",
    
    // Nutrient Blocking
    phosphorusBlocks: "Zinc (Zn), Iron (Fe), Copper (Cu)",
    potassiumBlocks: "Magnesium (Mg), Calcium (Ca)",
    nitrogenBlocks: "Copper (Cu), Boron (B)",
    
    // Table Headers - Fertilizer
    stage: "Stage",
    input: "Input",
    dose: "Dose",
    method: "Method",
    
    // Table Headers - Derived Insights
    indicator: "Indicator",
    condition: "Condition",
    imbalanceEffect: "Imbalance Effect",
    
    // Table Headers - Nutrient Blocking
    blockingTitle: "Points to Keep in Mind During Fertilizer Application",
    whenTooMuchOf: "When There Is Too Much Of...",
    itBlocks: "It Blocks...",
    
    // Table Headers - Crop Tips
    practice: "Practice",
    why: "Why",
    
    // Status/Levels
    low: "Low",
    medium: "Medium",
    high: "High",
    
    // Messages
    cropTipsNotAvailable: "Crop-Specific Tips Not Available",
    cropTipsNotAvailableDesc: "We don't have cultivation tips for \"{crop}\" at the moment. Please check back later or contact support for assistance.",
    availableCrops: "Available crops",
    fertilizerNotAvailable: "Fertilizer Recommendation Not Available",
    fertilizerNotAvailableDesc: "We don't have fertilizer recommendations for your soil at the moment. Please check back later or contact support for assistance.",
    
    // Derived Parameters Section
    derivedParametersSubtitle: "Additional soil fertility indicators for comprehensive analysis.",
    
    // Notes
    phosphorusNote: "Note: This report expresses phosphorus values as P₂O₅. To convert P₂O₅ to elemental P, multiply the value by 0.436.",
    
    // Disclaimer
    disclaimer: "DISCLAIMER",
    disclaimerText: "Results relate only to the sample as received and information provided by the client. Ekosight accepts no responsibility or liability for the origin, traceability or quality of samples prior to receipt by the laboratory, either of which may compromise the quality or accuracy of the results generated. No representation or warranty is given by Ekosight, or any member or employee as to the accuracy of any test method or test results. Any action you take upon the information on this report is strictly at your own risk, Ekosight will not be liable for the use of guidance in the report in respect of any business losses, including without limitation loss of or damage to profits, income, revenue, use, production, anticipated savings, business, contracts, commercial opportunities or goodwill. No part of this report may be reproduced or use for commercial or public use without permission in writing from Ekosight."
  },
  
  hindi: {
    // Header
    inAssociationWith: "के सहयोग से",
    
    // User Data Labels
    name: "नाम",
    mobile: "मोबाइल",
    address: "पता",
    cityState: "शहर/राज्य",
    previousCrop: "पिछली फसल",
    farmSize: "खेत का आकार",
    nextCrop: "अगली फसल",
    sampleCode: "नमूना कोड",
    treatmentType: "उपचार प्रकार",
    
    // Section Titles
    section1Title: "खंड 1: मिट्टी विश्लेषण सारांश",
    section1Subtitle: "यह आपकी मिट्टी के नमूने में हमने क्या परीक्षण किया है।",
    section2Title: "खंड 2: विस्तृत पोषक तत्व जानकारी",
    section2Subtitle: "प्रत्येक परीक्षण किए गए पैरामीटर में गहराई से जानकारी।",
    section3Title: "खंड 3: उर्वरक सिफारिश",
    section3Subtitle: "यह पृष्ठ आपको बताता है कि कौन से उर्वरक का उपयोग करना है, कितना और कब। इस योजना का पालन करें।",
    section4Title: "खंड 4: व्युत्पन्न अंतर्दृष्टि और पोषक संतुलन",
    section4Subtitle: "यह खंड गहरी जानकारी देता है। पढ़ना उपयोगी है लेकिन अनिवार्य नहीं।",
    section5Title: "खंड 5: फसल-विशिष्ट सुझाव",
    section5Subtitle: "खेती के लिए विशेषज्ञ सुझाव। बेहतर परिणामों के लिए इन प्रथाओं का पालन करें।",
    
    // Table Headers - Soil Analysis
    sNo: "क्र.सं.",
    parameter: "पैरामीटर",
    idealRange: "आदर्श सीमा",
    actualValue: "वास्तविक मान",
    status: "स्थिति",
    derivedParameters: "व्युत्पन्न पैरामीटर",
    
    // Table Headers - Detailed Insights
    fertilityRating: "उर्वरता रेटिंग",
    whatItMeans: "इसका क्या मतलब है?",
    functionInCropGrowth: "फसल वृद्धि में कार्य",
    
    // Nutrient Insights - Meanings
    phMeaning: "मिट्टी की अम्लता/क्षारीयता",
    ecMeaning: "मिट्टी में नमक का स्तर",
    ocMeaning: "मिट्टी में जैविक पदार्थ",
    nitrogenMeaning: "वृद्धि पोषक तत्व",
    phosphorusMeaning: "ऊर्जा स्थानांतरण",
    potassiumMeaning: "फल गुणवत्ता नियामक",
    sulphurMeaning: "प्रोटीन संश्लेषण",
    magnesiumMeaning: "क्लोरोफिल का केंद्र",
    calciumMeaning: "कोशिका शक्ति",
    zincMeaning: "वृद्धि हार्मोन समर्थन",
    ironMeaning: "क्लोरोफिल संश्लेषण",
    copperMeaning: "एंजाइम सक्रियक",
    boronMeaning: "परागण और फल सेट",
    
    // Nutrient Insights - Functions
    phFunction: "पोषक तत्व उपलब्धता और सूक्ष्मजीव गतिविधि को प्रभावित करता है",
    ecFunction: "जड़ में पानी के अवशोषण और पोषक घुलनशीलता को प्रभावित करता है",
    ocFunction: "सूक्ष्मजीव जीवन, संरचना और जल प्रतिधारण को बढ़ाता है",
    nitrogenFunction: "पत्तेदार वृद्धि और क्लोरोफिल निर्माण को बढ़ावा देता है",
    phosphorusFunction: "जड़ विकास और फूलों को समर्थन देता है",
    potassiumFunction: "पानी संतुलन, रोग प्रतिरोध, फल आकार में मदद करता है",
    sulphurFunction: "एंजाइम कार्य, तेल संश्लेषण और स्वाद में सुधार करता है",
    magnesiumFunction: "प्रकाश संश्लेषण और एंजाइम सक्रियता के लिए आवश्यक",
    calciumFunction: "मजबूत कोशिका दीवारें बनाता है, फूल गलन रोकता है",
    zincFunction: "एंजाइम सक्रियता, पत्ती विस्तार, जड़ों के लिए आवश्यक",
    ironFunction: "हरी पत्ती निर्माण और श्वसन का समर्थन करता है",
    copperFunction: "पराग व्यवहार्यता और रोग प्रतिरोध को प्रभावित करता है",
    boronFunction: "फूल, फल सेट, चीनी परिवहन और बीज निर्माण में सहायता करता है",
    
    // Derived Insights - Meanings
    cnRatioMeaning: "मिट्टी कार्बनिक कार्बन का उपलब्ध नाइट्रोजन से अनुपात",
    cecTendencyMeaning: "मिट्टी की पोषक तत्वों को पकड़ने और आदान-प्रदान करने की क्षमता (OC, Ca, Mg, K, pH पर आधारित)",
    caMgRatioMeaning: "मिट्टी में कैल्शियम और मैग्नीशियम स्तरों के बीच संतुलन",
    kMgRatioMeaning: "पोटैशियम और मैग्नीशियम उपलब्धता के बीच संतुलन",
    
    // Derived Insights - Functions
    cnRatioFunction: "जैविक पदार्थ की गुणवत्ता को इंगित करता है; सूक्ष्मजीव गतिविधि और नाइट्रोजन उपलब्धता को प्रभावित करता है",
    cecTendencyFunction: "जड़ में पानी के अवशोषण और पोषक घुलनशीलता को प्रभावित करता है",
    caMgRatioFunction: "मिट्टी की संरचना, वातन, पानी की गति और जड़ प्रवेश को प्रभावित करता है",
    kMgRatioFunction: "अवशोषण के लिए प्रतिस्पर्धा को नियंत्रित करता है; फल गुणवत्ता, तनाव सहनशीलता और पत्ती शक्ति को प्रभावित करता है",
    
    // Derived Indicators - Effects
    cnRatioLowEffect: "जैविक पदार्थ का तेजी से टूटना, नाइट्रेट रिसाव में वृद्धि",
    cnRatioHighEffect: "पोषक तत्व लॉक-अप, धीमी नाइट्रोजन खनिजीकरण",
    cecTendencyLowEffect: "खराब पोषक तत्व प्रतिधारण, रिसाव का अधिक जोखिम",
    cecTendencyHighEffect: "पोषक तत्व बहुत कसकर बंध सकते हैं",
    caMgRatioLowEffect: "मिट्टी का संघनन, खराब वातन, कम पानी घुसपैठ",
    caMgRatioHighEffect: "पोषक तत्व प्रतिपक्षता, विशेष रूप से Mg और K की कमी",
    kMgRatioLowEffect: "संभावित Mg अधिकता, फल परिपक्वता में देरी हो सकती है",
    kMgRatioHighEffect: "K, Mg को दबा देता है, कमजोर तने",
    
    // Nutrient Blocking
    phosphorusBlocks: "जिंक (Zn), आयरन (Fe), कॉपर (Cu)",
    potassiumBlocks: "मैग्नीशियम (Mg), कैल्शियम (Ca)",
    nitrogenBlocks: "कॉपर (Cu), बोरॉन (B)",
    
    // Table Headers - Fertilizer
    stage: "चरण",
    input: "इनपुट",
    dose: "खुराक",
    method: "विधि",
    
    // Table Headers - Derived Insights
    indicator: "संकेतक",
    condition: "स्थिति",
    imbalanceEffect: "असंतुलन प्रभाव",
    
    // Table Headers - Nutrient Blocking
    blockingTitle: "उर्वरक अनुप्रयोग के दौरान ध्यान रखने योग्य बातें",
    whenTooMuchOf: "जब बहुत अधिक हो...",
    itBlocks: "यह रोकता है...",
    
    // Table Headers - Crop Tips
    practice: "अभ्यास",
    why: "क्यों",
    
    // Status/Levels
    low: "कम",
    medium: "मध्यम",
    high: "उच्च",
    
    // Messages
    cropTipsNotAvailable: "फसल-विशिष्ट सुझाव उपलब्ध नहीं",
    cropTipsNotAvailableDesc: "हमारे पास \"{crop}\" के लिए खेती के सुझाव इस समय उपलब्ध नहीं हैं। कृपया बाद में जांचें या सहायता के लिए संपर्क करें।",
    availableCrops: "उपलब्ध फसलें",
    fertilizerNotAvailable: "उर्वरक सिफारिश उपलब्ध नहीं",
    fertilizerNotAvailableDesc: "हमारे पास आपकी मिट्टी के लिए उर्वरक सिफारिशें इस समय उपलब्ध नहीं हैं। कृपया बाद में जांचें या सहायता के लिए संपर्क करें।",
    
    // Derived Parameters Section
    derivedParametersSubtitle: "व्यापक विश्लेषण के लिए अतिरिक्त मिट्टी उर्वरता संकेतक।",
    
    // Notes
    phosphorusNote: "नोट: यह रिपोर्ट फास्फोरस मानों को P₂O₅ के रूप में व्यक्त करती है। P₂O₅ को तात्विक P में बदलने के लिए, मान को 0.436 से गुणा करें।",
    
    // Disclaimer
    disclaimer: "अस्वीकरण",
    disclaimerText: "परिणाम केवल प्राप्त नमूने और ग्राहक द्वारा प्रदान की गई जानकारी से संबंधित हैं। Ekosight प्रयोगशाला द्वारा प्राप्ति से पहले नमूनों की उत्पत्ति, पता लगाने योग्यता या गुणवत्ता के लिए कोई जिम्मेदारी या दायित्व स्वीकार नहीं करता है, जिनमें से कोई भी परिणामों की गुणवत्ता या सटीकता से समझौता कर सकता है। Ekosight, या किसी सदस्य या कर्मचारी द्वारा किसी परीक्षण विधि या परीक्षण परिणामों की सटीकता के बारे में कोई प्रतिनिधित्व या वारंटी नहीं दी जाती है। इस रिपोर्ट की जानकारी पर आप जो भी कार्रवाई करते हैं वह पूरी तरह से आपके अपने जोखिम पर है, Ekosight किसी भी व्यावसायिक नुकसान के संबंध में रिपोर्ट में मार्गदर्शन के उपयोग के लिए उत्तरदायी नहीं होगा, जिसमें मुनाफे, आय, राजस्व, उपयोग, उत्पादन, अनुमानित बचत, व्यवसाय, अनुबंध, वाणिज्यिक अवसरों या सद्भावना को बिना किसी सीमा के नुकसान या क्षति शामिल है। इस रिपोर्ट का कोई भी हिस्सा Ekosight से लिखित अनुमति के बिना वाणिज्यिक या सार्वजनिक उपयोग के लिए पुन: प्रस्तुत या उपयोग नहीं किया जा सकता है।"
  }
}

// Helper function to get translation
export const getTranslation = (language = 'english') => {
  const lang = language.toLowerCase()
  return translations[lang] || translations.english
}

